var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingScreenDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Donut-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "129.003906%",
    y1: "33.5351562%",
    x2: "73.828125%",
    y2: "85.5175781%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E65E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B440",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.637416295,
    strokeDasharray: 3.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loading-Interim-Animation",
    transform: "translate(8.000000, 8.000000)",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donut-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,80 C62.09139,80 80,62.09139 80,40 C80,17.90861 62.09139,0 40,0 C17.90861,0 0,17.90861 0,40 C0,62.09139 17.90861,80 40,80 Z",
    id: "Oval"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingScreenDonut);
export default __webpack_public_path__ + "static/media/Loading_Screen_Donut.963cfb1d.svg";
export { ForwardRef as ReactComponent };